// extracted by mini-css-extract-plugin
export default {"itemContainerStyle":"dashboard_itemContainerStyle__3TSjg","emptyContainerStyle":"dashboard_emptyContainerStyle__eWDmh"};